import { useState, useEffect } from 'react';

const useUbigeo = (
  disabled: boolean,
  generalApi: any,
  selectedDepartment: string,
  selectedProvince: string
) => {
  const [departments, setDepartments] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    const getDepartments = async () => {
      const result = await generalApi.get('/departments');
      if (!result.success) return;
      if (result.data) {
        setDepartments(result.data);
      }
    };
    if (!disabled) getDepartments();
  }, [generalApi, disabled]);

  useEffect(() => {
    const getProvinces = async () => {
      const result = await generalApi.get(`/provinces/${selectedDepartment}`);
      if (!result.success) return;
      if (result.data) {
        setProvinces(result.data);
      }
    };
    if (!disabled) getProvinces();
  }, [generalApi, disabled, selectedDepartment]);

  useEffect(() => {
    const getDistricts = async () => {
      const result = await generalApi.get(`/districts/${selectedProvince}`);
      if (!result.success) return;
      if (result.data) {
        setDistricts(result.data);
      }
    };
    if (!disabled) getDistricts();
  }, [generalApi, disabled, selectedProvince]);

  return [departments, provinces, districts];
};

export { useUbigeo };
